import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Grid, Tooltip } from '@mui/material';

import { Job } from '@libs/graphql-types';
import StepSection from '@libs/ui/components/step-section';

import { isBayerJob } from '../security-id-utils';
import { QuestionControl } from './QuestionControl';
import { Question } from './types';

interface QuestionsSectionProps {
  job: Job;
  sectionName: string;
  index: number;
  showOnlyRequired?: boolean;
}

export const QuestionsSection = ({
  job,
  sectionName,
  index,
  showOnlyRequired = false,
}: QuestionsSectionProps) => {
  const { t } = useTranslation('jobForm');
  const questions: Question[] = JSON.parse(
    job?.striive_job?.questions || '[]',
  ).filter((q: Question) => q.isCandidate === true);

  const filteredQuestions = showOnlyRequired
    ? questions.filter((q) => q.mandatory)
    : questions;

  const isBayer = isBayerJob(job);

  const getEndAdornment = (question: Question) => {
    if (
      !isBayer ||
      !question.question
        .toLowerCase()
        .replace(/[,()[\]{}]/g, '')
        .includes('if yes please state the following details')
    ) {
      return undefined;
    }

    return (
      <Tooltip
        title={
          <>
            1. Location
            <br />
            2. Bayer legal entity
            <br />
            3. Start date
            <br />
            4. Exit date
            <br />
            5. Candidate's/Independent Contractor's name at the time of
            employment
          </>
        }
      >
        <Box display="flex" alignItems="center" style={{ cursor: 'pointer' }}>
          <InfoOutlinedIcon />
        </Box>
      </Tooltip>
    );
  };

  return (
    <StepSection index={index} title={t('applicationForm.questions.title')}>
      <Grid spacing={4} direction="column" container>
        {filteredQuestions.map((question) => (
          <Grid item key={question.id}>
            <QuestionControl
              question={question}
              name={`${sectionName}.${question.recordId}`}
              endAdornment={getEndAdornment(question)}
            />
          </Grid>
        ))}
      </Grid>
    </StepSection>
  );
};
